import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=42a77f3a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=42a77f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a77f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a77f3a')) {
      api.createRecord('42a77f3a', component.options)
    } else {
      api.reload('42a77f3a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=42a77f3a&scoped=true&", function () {
      api.rerender('42a77f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QJr7G3fb1Rv2/JS/comp/GuestBox.vue"
export default component.exports